<template>
  <v-form ref="requestFormRef">
    <div class="container step__container">
      <div v-if="loading" class="loader-holder">
        <naj-loader></naj-loader>
      </div>
      <div class="card step__card">
        <div class="step__titleWrap scrollAnimation scrollAnimation--active">
          <div class="step__title">
            {{ local.judgementDeedsInquiry.title }}
          </div>
        </div>
        <div class="step__cardBody scrollAnimation scrollAnimation--active">
          <div class="step__text step__text--highlighted">
            {{ local.judgementDeedsInquiry.description }}
          </div>

          <v-row>
            <v-col cols="6">
              <naj-input
                :type-id="formFieldType.selectbox"
                :items="courts"
                :value.sync="searchQuery.courtId"
                item-text="name"
                item-value="id"
                :label="local.judgementDeedsInquiry.court"
                validates="required"
              ></naj-input>
            </v-col>
            <v-col cols="6">
              <naj-input
                :type-id="formFieldType.text"
                :value.sync="searchQuery.caseCode"
                :label="local.judgementDeedsInquiry.caseCode"
                validates="required|only-digits"
              ></naj-input>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <naj-input
                :type-id="formFieldType.text"
                :value.sync="searchQuery.judgmentCode"
                :label="local.judgementDeedsInquiry.deedNumber"
                validates="required|only-digits"
              ></naj-input>
            </v-col>
            <v-col cols="6">
              <naj-input
                :type-id="formFieldType.selectbox"
                :items="partyRoles"
                :value.sync="searchQuery.partyCaseRoleId"
                item-text="name"
                item-value="id"
                :label="local.judgementDeedsInquiry.partyRole"
                validates="required"
              ></naj-input>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <naj-input
                :type-id="formFieldType.selectbox"
                :items="socialTypes"
                :value.sync="searchQuery.partyIdentityTypeId"
                item-text="name"
                item-value="id"
                :label="local.judgementDeedsInquiry.casePartyIdentityType"
                validates="required"
              ></naj-input>
            </v-col>
            <v-col cols="6">
              <naj-input
                :type-id="formFieldType.text"
                :label="local.judgementDeedsInquiry.casePartyIdentityNumber"
                :value.sync="searchQuery.partyIdentityId"
                validates="required|only-digits"
                :maxlength="10"
              ></naj-input>
            </v-col>
          </v-row>
        </div>

        <template v-if="!isAuthenticated">
          <v-row>
            <v-col cols="6">
              <naj-input
                :type-id="formFieldType.selectbox"
                :items="socialIdTypes"
                :value.sync="searchQuery.inquireSocialTypeId"
                item-text="name"
                item-value="id"
                :label="local.judgementDeedsInquiry.inquireIdentityType"
                validates="required"
              ></naj-input>
            </v-col>
            <v-col cols="6">
              <naj-input
                :type-id="formFieldType.text"
                :value.sync="searchQuery.inquireSocialId"
                :label="local.judgementDeedsInquiry.inquireIdentityNumber"
                validates="required|only-digits"
                :maxlength="10"
              ></naj-input>
            </v-col>
          </v-row>
          <div class="step__recaptcha" v-if="isRecaptchaEnabled">
            <Recaptcha
              :sitekey="recaptchaKey"
              :verify="onVerify"
              :expired="onExpired"
              ref="recaptcha"
              :class="{ not_valid: !isValidreCaptchaToken }"
            ></Recaptcha>

            <span v-if="Recaptcha.isChecked" style="color: red;">*</span>
          </div>
        </template>
        <v-row>
          <v-col cols="12" class="text-left">
            <naj-button @click="submit">
              {{ local.judgementDeedsInquiry.submit }}
            </naj-button>
          </v-col>
        </v-row>
      </div>
      <div v-if="viewNafathOtp">
        <naj-nafath-otp-input
          ref="nafathmodal"
          :route="local.otp.title"
          :show-modal="viewNafathOtp"
          :identity-number="searchQuery.inquireSocialId"
          :service-type="nafathServiceTypes.inquireAboutTheJudgmentDeed"
          @onCancelModal="viewNafathOtp = false"
          @authenticationSuccess="inquireJudgement"
        >
        </naj-nafath-otp-input>
      </div>
    </div>
  </v-form>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Recaptcha from '@t2/recaptcha';
import { resetScroll } from '@/helpers/utils';
import { nafathServiceTypes } from '@/helpers/enum';
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

const { mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  name: 'JudgementDeedsInquiry',
  components: {
    Recaptcha,
  },
  data() {
    return {
      currentUrl: window.location.href,
      showResendButton: true,
      Recaptcha: {
        isChecked: false,
        value: '',
      },
      isRecaptchaEnabled: false,
      recaptchaKey: '',
      searchQuery: {
        systemCode: 1
      },
      loading: false,
      viewNafathOtp: false,
      isValidreCaptchaToken: true,
      allSocialTypes: [],
      nafathServiceTypes,
    };
  },
  mounted() {
    this.loading = true;
    Promise.all([this.getCourts(), this.getRecaptchaConfig(), this.getSocialTypes()])
      .then((resultArray) => {
        this.isRecaptchaEnabled = resultArray[1].data.Recaptcha.Enabled;
        this.recaptchaKey = resultArray[1].data.Recaptcha.Key;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  created() {},
  computed: {
    ...mapLUTState(['partyRoles', 'socialIdTypes','courts', 'socialTypes']),
    ...mapGlobalState(['userInfo']),
    isAuthenticated() {
      return this.userInfo != null && this.userInfo.userType;
    },
  },
  methods: {
    ...mapLUTActions(['getCourts', 'getSocialTypes']),
    ...mapGlobalActions(['getRecaptchaConfig']),
    ...mapActions(['getJudgementDeeds']),
    downloadPDF(pdf) {
      const linkSource = `data:application/pdf;base64,${pdf}`;
      const downloadLink = document.createElement('a');
      const fileName = this.searchQuery.judgmentCode + '.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
    onVerify(e) {
      this.Recaptcha.isChecked = true;
      this.Recaptcha.value = e;
      this.isValidreCaptchaToken = true;
    },
    onExpired(e) {
      this.Recaptcha.isChecked = false;
      this.Recaptcha.value = e;
      this.isValidreCaptchaToken = false;
    },
    submit() {
      this.$refs.requestFormRef.$validator.validateAll().then((valid) => {
        if (valid && this.isValidreCaptchaToken) {
          if (this.isAuthenticated) this.inquireJudgement();
          else this.viewNafathOtp = true;
        } else {
          resetScroll();
        }
      });
    },
    inquireJudgement() {
      this.viewNafathOtp = false;
      this.loading = true;
      this.getJudgementDeeds(this.searchQuery)
        .then((response) => {
          this.downloadPDF(response.data.deedContent);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {},
};
</script>
